<script lang="ts">
	import privacyHtml from '$lib/legal/privacy-content.html?raw';
</script>

<svelte:head>
	<title>Privacy Policy - Piefect</title>
	<meta name="description" content="Privacy Policy for Piefect expense sharing application." />
</svelte:head>

<div class="mx-auto max-w-4xl px-6 py-16">
	<article class="prose prose-sage max-w-none">
		{@html privacyHtml}
	</article>
</div>
